export default {
    scrolledPastNav: false,
};
